import React, { useState, useEffect } from "react";
import notificationService from "../../services/notificationService";
import NotificationPanel from "./NotificationPanel.jsx";
import "./NotificationBell.css";

export const NotificationBell = ({ userId }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!userId) {
      return;
    }
    try {
      const unsubscribe = notificationService.subscribeToNotifications(
        userId,
        (notifications) => {
          const unread = notifications.filter((n) => !n.isRead).length;
          setUnreadCount(unread);
        }
      );

      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error("❌ NotificationBell Error:", error);
    }
  }, [userId]);

  if (!userId) {
    return null;
  }

  return (
    <>
      <button
        className="notification-bell-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Notifications"
        aria-label="View notifications"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </button>

      <NotificationPanel
        userId={userId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default NotificationBell;

